import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../home/Navbar';
import Queryform from './Queryform';
import Footer from '../home/Footer';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const KundliMatchingResult = () => {
    const location = useLocation();
    const { planetsDetails, matchAscendant } = location.state;
    const boyPlanets = Object.values(planetsDetails.boy_planetary_details || {});
    const girlPlanets = Object.values(planetsDetails.girl_planetary_details || {});

    const kundliRef = useRef(null);

    const handleDownloadPDF = async () => {
        const input = kundliRef.current;

        // Scroll to top to avoid partial capture
        window.scrollTo(0, 0);

        // Take screenshot of full content
        const canvas = await html2canvas(input, {
            scale: 2,
            useCORS: true,
            windowWidth: document.documentElement.scrollWidth,
            windowHeight: document.documentElement.scrollHeight
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.9);
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        const imgProps = {
            width: canvas.width,
            height: canvas.height
        };

        const pdf = new jsPDF("p", "mm", "a4");

        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        pdf.save("kundli-matching-details.pdf");
    };


    return (
        <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
            <Navbar />
            <div ref={kundliRef} className="p-6 md:p-12 max-w-7xl mx-auto">
                <h1 className="text-3xl sm:text-4xl font-serif font-bold text-secondary text-center">Kundli Matching Details</h1>


                {/* Section 1: Ashtakoot Score */}
                <div className="bg-slate-200 shadow-lg rounded-xl p-6 sm:p-8 md:p-10 mt-6 mb-8 transition-all text-center duration-300">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">💫 Ashtakoot Score</h2>
                    <div className="text-gray-700 bg-white rounded-md p-2 text-base sm:text-lg space-y-2">
                        <p><span className="font-semibold">Score:</span> {planetsDetails.score} / 36</p>
                        <p>{planetsDetails.bot_response}</p>
                    </div>
                </div>

                {/* Section 2: Dosha and Compatibility Overview */}
                <div className="bg-slate-200 shadow-lg rounded-xl p-6 sm:p-8 md:p-10 mb-8 transition-all duration-300">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">🧿 Dosha & Compatibility Overview</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 bg-white p-4 rounded-md text-gray-800 text-sm sm:text-base">
                        <p><strong>Compatibility Score:</strong> {matchAscendant.score} / 100</p>
                        <p><strong>Ashtakoot Score:</strong> {matchAscendant.ashtakoot_score}</p>
                        <p><strong>Dashkoot Score:</strong> {matchAscendant.dashkoot_score}</p>
                        <p><strong>Mangal Dosh:</strong> {matchAscendant.mangaldosh}</p>
                        <p><strong>Boy Mangal Points:</strong> {matchAscendant.mangaldosh_points?.boy}</p>
                        <p><strong>Girl Mangal Points:</strong> {matchAscendant.mangaldosh_points?.girl}</p>
                        <p><strong>Rahu/Ketu Manglik Dosh:</strong> {matchAscendant.manglikdosh_rahuketu}</p>
                        <p><strong>Saturn Manglik Dosh:</strong> {matchAscendant.manglikdosh_saturn}</p>
                        <p><strong>Pitra Dosh:</strong> {matchAscendant.pitradosh}</p>
                        <p><strong>Kaal Sarp Dosh:</strong> {matchAscendant.kaalsarpdosh}</p>
                        <p><strong>Rajju Dosh:</strong> {matchAscendant.rajjudosh ? "Present" : "Absent"}</p>
                        <p><strong>Veda Dosh:</strong> {matchAscendant.vedhadosh ? "Present" : "Absent"}</p>
                    </div>
                    <div className="mt-6 space-y-4">
                        <p className="text-gray-900 bg-[#fdca6e] rounded-md p-2 font-semibold">{matchAscendant.extended_response}</p>
                        <p className="text-gray-900 bg-[#fdca6e] rounded-md p-2 font-semibold">{matchAscendant.bot_response}</p>
                    </div>
                </div>


                {/* Section 3: Boy's Planetary Details */}
                <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8 md:p-10 mb-4">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">👦 Boy's Planetary Details</h2>
                    <div className="overflow-x-auto">
                        <Table className="min-w-full border text-lg text-gray-700">
                            <Thead className="bg-gray-100 text-base uppercase font-bold">
                                <Tr>
                                    <Th className="px-4 py-2">Planet</Th>
                                    <Th className="px-4 py-2">Zodiac</Th>
                                    <Th className="px-4 py-2">House</Th>
                                    <Th className="px-4 py-2">Nakshatra</Th>
                                    <Th className="px-4 py-2">Avastha</Th>
                                    <Th className="px-4 py-2">Lord Status</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {boyPlanets.map((planet, idx) => (
                                    <Tr key={idx} className="border-b">
                                        <Td className="px-4 py-2">{planet.full_name}</Td>
                                        <Td className="px-4 py-2">{planet.zodiac}</Td>
                                        <Td className="px-4 py-2">{planet.house}</Td>
                                        <Td className="px-4 py-2">{planet.nakshatra}</Td>
                                        <Td className="px-4 py-2">{planet.basic_avastha}</Td>
                                        <Td className="px-4 py-2">{planet.lord_status}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                </div>

                {/* Section 4: Girl's Planetary Details */}
                <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8 md:p-10 mb-4">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">👧 Girl's Planetary Details</h2>
                    <div className="overflow-x-auto">
                        <Table className="min-w-full border text-lg text-gray-700">
                            <Thead className="bg-gray-100 text-base uppercase font-bold">
                                <Tr>
                                    <Th className="px-4 py-2">Planet</Th>
                                    <Th className="px-4 py-2">Zodiac</Th>
                                    <Th className="px-4 py-2">House</Th>
                                    <Th className="px-4 py-2">Nakshatra</Th>
                                    <Th className="px-4 py-2">Avastha</Th>
                                    <Th className="px-4 py-2">Lord Status</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {girlPlanets.map((planet, idx) => (
                                    <Tr key={idx} className="border-b">
                                        <Td className="px-4 py-2">{planet.full_name}</Td>
                                        <Td className="px-4 py-2">{planet.zodiac}</Td>
                                        <Td className="px-4 py-2">{planet.house}</Td>
                                        <Td className="px-4 py-2">{planet.nakshatra}</Td>
                                        <Td className="px-4 py-2">{planet.basic_avastha}</Td>
                                        <Td className="px-4 py-2">{planet.lord_status}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </div>
                </div>

                {/* Section 5: Compatibility Factors */}
                <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8 md:p-10 mb-4">
                    <h2 className="text-2xl sm:text-3xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">💞 Compatibility Factors</h2>
                    <div className="overflow-x-auto">
                        <Table className="min-w-full border text-lg text-gray-700">
                            <Thead className="bg-gray-100 text-base uppercase font-bold">
                                <Tr>
                                    <Th className="px-4 py-2">Factor</Th>
                                    <Th className="px-4 py-2">Boy</Th>
                                    <Th className="px-4 py-2">Girl</Th>
                                    <Th className="px-4 py-2">Score</Th>
                                    <Th className="px-4 py-2">Out of</Th>
                                    <Th className="px-4 py-2">Description</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {['grahamaitri', 'nadi', 'tara', 'varna', 'vasya', 'yoni'].map((key) => {
                                    const item = planetsDetails[key];
                                    return (
                                        <Tr key={key} className="border-b">
                                            <Td className="px-4 py-2 font-medium">{item?.name || key}</Td>
                                            <Td className="px-4 py-2">{item?.[`boy_${key}`] || item?.boy_lord || item?.boy_varna || '-'}</Td>
                                            <Td className="px-4 py-2">{item?.[`girl_${key}`] || item?.girl_lord || item?.girl_varna || '-'}</Td>
                                            <Td className="px-4 py-2">{item?.[key]}</Td>
                                            <Td className="px-4 py-2">{item?.full_score}</Td>
                                            <Td className="px-4 py-2">{item?.description}</Td>
                                        </Tr>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    </div>
                </div>

                {/* Section 6: Individual Astro Details */}
                <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8 md:p-10 mb-2">
                    <h2 className="text-2xl sm:text-3xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-6">🔮 Individual Astro Details</h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Boy Astro Details */}
                        <div className="bg-blue-100 rounded-lg p-4 shadow-sm">
                            <h3 className="text-xl font-semibold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">👦 Boy</h3>
                            <ul className="text-gray-800 text-base space-y-2">
                                <li><strong>Ascendant Sign:</strong> {planetsDetails.boy_astro_details.ascendant_sign}</li>
                                <li><strong>Rasi:</strong> {planetsDetails.boy_astro_details.rasi}</li>
                                <li><strong>Nakshatra:</strong> {planetsDetails.boy_astro_details.nakshatra} (Pada {planetsDetails.boy_astro_details.nakshatra_pada})</li>
                                <li><strong>Birth Dasa:</strong> {planetsDetails.boy_astro_details.birth_dasa} ({planetsDetails.boy_astro_details.birth_dasa_time})</li>
                                <li><strong>Current Dasa:</strong> {planetsDetails.boy_astro_details.current_dasa} ({planetsDetails.boy_astro_details.current_dasa_time})</li>
                                <li><strong>Gana:</strong> {planetsDetails.boy_astro_details.gana}</li>
                                <li><strong>Yoni:</strong> {planetsDetails.boy_astro_details.yoni}</li>
                                <li><strong>Vasya:</strong> {planetsDetails.boy_astro_details.vasya}</li>
                                <li><strong>Nadi:</strong> {planetsDetails.boy_astro_details.nadi}</li>
                                <li><strong>Varna:</strong> {planetsDetails.boy_astro_details.varna}</li>
                                <li><strong>Element (Tatva):</strong> {planetsDetails.boy_astro_details.tatva}</li>
                                <li><strong>Paya:</strong> {planetsDetails.boy_astro_details.paya}</li>
                                <li><strong>Lucky Gem:</strong> {planetsDetails.boy_astro_details.lucky_gem?.join(', ')}</li>
                                <li><strong>Lucky Numbers:</strong> {planetsDetails.boy_astro_details.lucky_num?.join(', ')}</li>
                                <li><strong>Lucky Colors:</strong> {planetsDetails.boy_astro_details.lucky_colors?.join(', ')}</li>
                                <li><strong>Lucky Letters:</strong> {planetsDetails.boy_astro_details.lucky_letters?.join(', ')}</li>
                                <li><strong>Lucky Name Starts:</strong> {planetsDetails.boy_astro_details.lucky_name_start?.join(', ')}</li>
                            </ul>
                        </div>

                        {/* Girl Astro Details */}
                        <div className="bg-pink-100 rounded-lg p-4 shadow-sm">
                            <h3 className="text-xl font-semibold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-2 mb-4 text-center">👧 Girl</h3>
                            <ul className="text-gray-800 text-base space-y-2">
                                <li><strong>Ascendant Sign:</strong> {planetsDetails.girl_astro_details.ascendant_sign}</li>
                                <li><strong>Rasi:</strong> {planetsDetails.girl_astro_details.rasi}</li>
                                <li><strong>Nakshatra:</strong> {planetsDetails.girl_astro_details.nakshatra} (Pada {planetsDetails.girl_astro_details.nakshatra_pada})</li>
                                <li><strong>Birth Dasa:</strong> {planetsDetails.girl_astro_details.birth_dasa} ({planetsDetails.girl_astro_details.birth_dasa_time})</li>
                                <li><strong>Current Dasa:</strong> {planetsDetails.girl_astro_details.current_dasa} ({planetsDetails.girl_astro_details.current_dasa_time})</li>
                                <li><strong>Gana:</strong> {planetsDetails.girl_astro_details.gana}</li>
                                <li><strong>Yoni:</strong> {planetsDetails.girl_astro_details.yoni}</li>
                                <li><strong>Vasya:</strong> {planetsDetails.girl_astro_details.vasya}</li>
                                <li><strong>Nadi:</strong> {planetsDetails.girl_astro_details.nadi}</li>
                                <li><strong>Varna:</strong> {planetsDetails.girl_astro_details.varna}</li>
                                <li><strong>Element (Tatva):</strong> {planetsDetails.girl_astro_details.tatva}</li>
                                <li><strong>Paya:</strong> {planetsDetails.girl_astro_details.paya}</li>
                                <li><strong>Lucky Gem:</strong> {planetsDetails.girl_astro_details.lucky_gem?.join(', ')}</li>
                                <li><strong>Lucky Numbers:</strong> {planetsDetails.girl_astro_details.lucky_num?.join(', ')}</li>
                                <li><strong>Lucky Colors:</strong> {planetsDetails.girl_astro_details.lucky_colors?.join(', ')}</li>
                                <li><strong>Lucky Letters:</strong> {planetsDetails.girl_astro_details.lucky_letters?.join(', ')}</li>
                                <li><strong>Lucky Name Starts:</strong> {planetsDetails.girl_astro_details.lucky_name_start?.join(', ')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* button to download kundli details */}
            <div className=' w-full flex justify-center'>
                <button className='bg-gray-900 hover:bg-secondary transition-all duration-300 text-white w-1/2 py-2 rounded-md' onClick={handleDownloadPDF}>Download Kundli Matching Details</button>
            </div>
            <Queryform />
            <Footer />
        </section>
    );
};

export default KundliMatchingResult;
